<template>
  <router-view v-if="isLoad"></router-view>
</template>
<script>
  import Vue from 'vue'
  import Vant from 'vant';
  import 'vant/lib/index.css';
  Vue.use(Vant)
  export default {
    watch: {
      '$route' (to, from) {
        document.title = to.meta.title;
      }
    },
    data () {
      return {
        isLoad: false
      }
    },
    mounted () {
      this.$wxtool.GetUserId().then((code) => {
        if (code) {//GetTokenByUserID
          this.Ajax.Get("/api/Login/GetTokenByCode/" + this.$config.LoginAppId + "/" + code).then(res => {
            this.$tool.ss.Set(this.$config.LoginToken, JSON.stringify(res.data));
            this.Ajax.Get("/api/Role/GetRole").then(role => {
              res.data.role = role.data;
              this.$tool.ss.Set(this.$config.LoginToken, JSON.stringify(res.data));
              setTimeout(() => {
                this.isLoad = true;
                if (this.$router.history.current.name == "Phone") {
                  this.$router.push({ name: "WagesIndex_P" });
                }
              }, 500);
            })
          })
        } else {
          if (this.$tool.ss.Get(this.$config.LoginToken)) {
            var data = JSON.parse(this.$tool.ss.Get(this.$config.LoginToken))
            setTimeout(() => {
              this.isLoad = true;
              if (this.$router.history.current.name == "Phone") {
                this.$router.push({ name: "WagesIndex_P" });
              }

            }, 500);
          } else {
            setTimeout(() => {
              this.isLoad = true;
              this.$router.push({ name: "p404" });
            }, 500);
          }
        }
      }).catch(() => {
        //this.$router.push({ name: "Bind" });
        this.$tool.Phone.alert("获取身份错误");
      });
    },
  }
</script>

